import { colorsPalettes, colorsSets } from "@similarweb/styles";

import type { AeoCampaignType } from "app/components/AeoCampaignModal/utils/campaignTypes";
import { AEO_THEME, AEO_WITH_FEATURES_THEME } from "app/components/discountCampaign/CampaignPromoModal/themePresets";
import type { ICampaignScenarioConfig } from "app/components/discountCampaign/campaignScenarioConfig.types";

/** Shared AEO campaign constants. Matches similarweb-backend aeoCampaignConstants. */
const AEO_CAMPAIGN_DATES = { startDate: "2026-02-01", endDate: "2026-01-01" };

export const AEO_PROMO_CODES: Record<AeoCampaignType, string> = {
    ciMonthlyToAnnual: "CIANNUAL30",
    ciAnnualToAeo: "AEO30",
    aeoMonthlyToAnnual: "ANNUAL30",
};

const AEO_BANNER_GRADIENT = `linear-gradient(90deg, ${colorsPalettes.carbon[500]} 0%, ${colorsSets.marketingGenAI.primary} 60%, ${colorsSets.marketingGenAI.accent} 100%)`;

const CAMPAIGN_DISCOUNT_PERCENTAGE = 30;

export const AEO_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL = new Set<string>([
    AEO_PROMO_CODES.ciMonthlyToAnnual,
    AEO_PROMO_CODES.aeoMonthlyToAnnual,
]);

/** AEO campaign config per user scenario ({@link getAeoCampaignType}). */
export const AEO_CAMPAIGN_CONFIG: Record<AeoCampaignType, ICampaignScenarioConfig> = {
    ciMonthlyToAnnual: {
        discountConfig: AEO_CAMPAIGN_DATES,
        banner: {
            theme: {
                color: colorsPalettes.carbon[0],
                background: AEO_BANNER_GRADIENT,
                counterColor: colorsSets.marketingGenAI.secondary,
                showButton: true,
                showTimer: true,
            },
            content: {
                title: "discount.banner.upgrade.lightning",
                text: "discount.get_upgrade.annual.banner.text",
                couponCode: AEO_PROMO_CODES.ciMonthlyToAnnual,
                percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
            },
        },
        modal: {
            theme: AEO_THEME,
            content: {
                title: "promo.limited.time.upgrade",
                text: "promo.and.get",
                subText: "promo.for.annual.upgrades",
                getDiscountText: "promo.get.your.discount",
                buttonText: "discount.cta.banner.button",
                percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
                discountCode: AEO_PROMO_CODES.ciMonthlyToAnnual,
            },
        },
    },
    ciAnnualToAeo: {
        discountConfig: AEO_CAMPAIGN_DATES,
        banner: {
            theme: {
                color: colorsPalettes.carbon[0],
                background: AEO_BANNER_GRADIENT,
                counterColor: colorsSets.marketingGenAI.secondary,
                showButton: true,
                showTimer: true,
            },
            content: {
                title: "discount.aeo.title",
                text: "discount.get_upgrade.aeo_seo.banner.text",
                couponCode: AEO_PROMO_CODES.ciAnnualToAeo,
                percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
            },
        },
        modal: {
            theme: AEO_WITH_FEATURES_THEME,
            content: {
                title: "discount.modal.aeo.title",
                text: "promo.update.and.get",
                subText: "promo.for.aeo.seo",
                getDiscountText: "promo.get.your.discount",
                buttonText: "discount.cta.banner.button",
                percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
                discountCode: AEO_PROMO_CODES.ciAnnualToAeo,
            },
            features: {
                title: "discount.unlock.with.seo_aeo",
                items: [
                    "aeo.promo.features1",
                    "aeo.promo.features2",
                    "aeo.promo.features3",
                    "aeo.promo.features4",
                    "aeo.promo.features5",
                ],
            },
        },
    },
    aeoMonthlyToAnnual: {
        discountConfig: AEO_CAMPAIGN_DATES,
        banner: {
            theme: {
                color: colorsPalettes.carbon[0],
                background: AEO_BANNER_GRADIENT,
                counterColor: colorsSets.marketingGenAI.secondary,
                showButton: true,
                showTimer: true,
            },
            content: {
                title: "discount.aeo.title",
                text: "discount.get_upgrade.annual.banner.text",
                couponCode: AEO_PROMO_CODES.aeoMonthlyToAnnual,
                percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
            },
        },
        modal: {
            theme: AEO_THEME,
            content: {
                title: "discount.modal.aeo.title",
                text: "promo.update.and.get",
                subText: "promo.for.annual.upgrades",
                getDiscountText: "promo.get.your.discount",
                buttonText: "discount.cta.banner.button",
                percentage: CAMPAIGN_DISCOUNT_PERCENTAGE,
                discountCode: AEO_PROMO_CODES.aeoMonthlyToAnnual,
            },
        },
    },
};
